import jsPDF from 'jspdf';
import {autoTable} from 'jspdf-autotable';
import textVersion from 'textversionjs';
import {byCategory, SECTION_TITLES} from '../containers/AnswersList';
import * as rptHelpers from '../Reports/ReportHelpers';

export function createAnswerRpt(fishery, pageOrientation, pageFormat, answers, monitoringQuestions, assessmentQuestions, controlRulesQuestions, categories, sections, includeNotes, includeBookmarks, translation){
  var doc = new jsPDF(pageOrientation, 'mm', pageFormat);
  var formatValues = rptHelpers.getFormatValues(doc);

  //*********************
  //Title Page
  //*********************

  //title
  doc.setFontSize(32);
  doc.setFont(rptHelpers.RPTFONTSTYLE,"bold");
  var yPos = 35;
  doc.text(formatValues.titleXPos, yPos, "FishPath Questionnaire \nand User Responses for", null, null, 'center');
  yPos+=25
  doc.text(formatValues.titleXPos, yPos, fishery, null, null, 'center');

  //logo
  rptHelpers.placeTitleLogo(doc)

  //date
  yPos += 30;
  var date = new Date();
  doc.setFontSize(20);
  doc.text(formatValues.titleXPos, yPos, "Report Generated on " + date.toLocaleDateString("en-us", {year: 'numeric', day: 'numeric', month:'long'}), null, null, 'center');

  //*********************
  //Question and Answer Table
  //*********************
  var columns = [
    {title: "Question", dataKey:"q"},
    {title: "Answer", dataKey:"answer"}
  ];

  if(includeNotes){
    columns.push({title: "Notes", dataKey:"notes"})
  }

  if(includeBookmarks){
    columns.unshift({title: "Book\nmarked", dataKey:"bookmark"}) //put at beginning
  }

  var data = [];
  var pageWidthToSplit = includeBookmarks ? doc.internal.pageSize.getWidth() - 16 : doc.internal.pageSize.getWidth(); //accomodate the bookmark column width before splitting the remaining between the other columns
  var columnWidth = includeNotes ? (pageWidthToSplit-(2*rptHelpers.HMARGIN))/3 : (pageWidthToSplit-(2*rptHelpers.HMARGIN))/2; //make the columns equal width

  //sorted version (mirrors from answers list page)
  sections.forEach((section) => {
    //make a new header for each section
    doc.addPage();
    yPos = 15;
    doc.setFontSize(25)
    doc.setFont(rptHelpers.RPTFONTSTYLE,'normal');
    doc.text(rptHelpers.HMARGIN, yPos, SECTION_TITLES[section] + " Answers");
    yPos+=10;

    var secQuestions;
    if(section === "monitoring"){
      secQuestions = monitoringQuestions;
    } else if(section === "assessment"){
      secQuestions = assessmentQuestions;
    } else{
      secQuestions = controlRulesQuestions;
    }

    categories.forEach((cat) => {
      //create a table of Q&As for each category within each section
      //loop through the question list for this section and find the ones that match this cat

      var catQuestions = secQuestions.filter(byCategory(cat))
      data = [];
      if(catQuestions.length > 0){
        yPos = rptHelpers.addSubHeader(doc, yPos, "Category: " + cat.title);

        catQuestions.forEach((catQ) => {
          var answerText = catQ.answerText ? rptHelpers.convertTextForjsPDF(catQ.answerText) : "No Answer Given";
          var note = (catQ.answerText && answers[catQ.id].note) ? textVersion(answers[catQ.id].note) : "";
          var qTitle = catQ.title

          if(translation){
            var trQ = translation.questions.find(trQ => trQ.engID === catQ.id)
            if(trQ){
                qTitle = trQ.title
                if(answerText !== "No Answer Given"){
                  //TODO: update with hardcord string translation
                  let answerID = catQ.answers.find(a => a.title === catQ.answerText).id
                  answerText = trQ.answers.find(a => a.id === answerID).title
                }
            }
          }

          data.push({
            bookmark: catQ.flagged ? "X" : "",
            q: rptHelpers.convertTextForjsPDF(qTitle),
            answer: answerText,
            notes: rptHelpers.convertTextForjsPDF(note)
          })
        })
        doc.autoTable(columns, data, {
          styles: {overflow: 'linebreak'},
          columnStyles: {bookmark:{columnWidth:16 , halign:'center'}, q: {columnWidth: columnWidth+10}, answer: {columnWidth: columnWidth-10}},
          startY: yPos,
          showHeader: 'firstPage',
          addPageContent: rptHelpers.tableFooter,
          margin: {horizontal: rptHelpers.HMARGIN, bottom: 19},
          rowPageBreak: 'avoid'
        })
        yPos = doc.autoTable.previous.finalY + 15;
      }
    });
  });

  var blob = doc.output("blob");
  window.open(URL.createObjectURL(blob));
}
